import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import merge from 'lodash.merge';
import Wrapper from 'src/Wrapper';

import { Palette } from 'src/components';
import { Style1 } from 'src/styles';
import { stylePropType } from 'src/PropTypes';

function Histogram({ title, style, series, options, theme: themeProp, onThemeChange, showPalette: showPaletteProp }) {
  const [theme, setTheme] = useState(themeProp);
  const [showPalette, setShowPalette] = useState(series.length < 2 ? showPaletteProp : false);

  useEffect(() => {
    setTheme(themeProp);
  }, [themeProp]);

  useEffect(() => {
    setShowPalette(series.length < 2 ? showPaletteProp : false);
  }, [series, showPaletteProp]);

  const chartOption = {
    title: {
      text: title,
      ...style.global.title,
    },
    grid: {
      ...style.Histogram.grid,
    },
    textStyle: {
      ...style.Histogram.textStyle,
    },
    label: {
      ...style.Histogram.label,
    },
    tooltip: {
      ...style.Histogram.tooltip,
    },
    legend: {
      ...style.Histogram.legend,
    },
    xAxis: {
      ...style.Histogram.xAxis,
    },
    yAxis: {
      ...style.Histogram.yAxis,
    },
    series,
  };
  const mergedOptions = merge({}, chartOption, options);
  return (
    <Wrapper>
      <ReactEcharts
        style={{
          width: '100%',
          height: showPalette ? 'calc(100% - 2.5rem)' : '100%',
        }}
        option={mergedOptions}
        theme={theme}
        notMerge
      />
      {showPalette ? (
        <Palette
          defaultTheme={theme}
          selected={theme}
          onSelect={(newTheme) => {
            setTheme(newTheme);
            onThemeChange(newTheme);
          }}
          style={{
            backgroundColor: mergedOptions.backgroundColor,
            width: '10rem',
            margin: '0 auto',
            paddingTop: '0.5rem',
          }}
        />
      ) : null}
    </Wrapper>
  );
}

Histogram.propTypes = {
  title: PropTypes.string,
  style: stylePropType,
  series: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.number),
    })
  ),
  options: PropTypes.shape({}),
  theme: PropTypes.string,
  onThemeChange: PropTypes.func,
  showPalette: PropTypes.bool,
};

Histogram.defaultProps = {
  title: '',
  style: Style1,
  series: [],
  options: {},
  theme: 'pinpoint',
  onThemeChange: () => null,
  showPalette: true,
};

export default Histogram;
